export const BASE_URL = 'https://services.finsights.biz/finsightspaymentsapi';
export const INVOICE_URL =
  'https://services.finsights.biz/finsightsinvoicereportsapi';
